import type { KeenSliderOptions, KeenSliderPlugin } from "keen-slider";
import query from "../supports/query";
import ready from "../supports/ready";

import KeenSlider from 'keen-slider';
import AutoplayPlugin from "./keen-slider/autoplay-plugin";
import ControlsPlugin from "./keen-slider/controls-plugin";
import FadePlugin from "./keen-slider/fade-plugin";
import IndicatorsPlugin from "./keen-slider/indicators-plugin";
import MarqueePlugin from "./keen-slider/marquee-plugin";
import ZoomPlugin from "./keen-slider/zoom-plugin";

/**
 * Invoke Keen Slider
 * @param target 
 */
function invokeKeenSlider(target: HTMLElement) {
    const plugins: KeenSliderPlugin[] = [];
    const options: KeenSliderOptions = {
        drag: target.dataset.keenDrag === '1',
        loop: target.dataset.keenLoop === '1',
    };

    // AutoPlay plugin
    const autoplay = parseInt(target.dataset.keenAutoplay || '');
    if (!isNaN(autoplay) && autoplay > 0) {
        plugins.push(AutoplayPlugin(target, options));
    }

    // Marquee Plugin
    if (target.dataset.keenMode === 'marquee') {
        plugins.push(MarqueePlugin(target, options));
    }

    // Animation Plugin
    if (target.dataset.keenMode !== 'marquee') {
        if (target.dataset.keenTransition == 'fade') {
            plugins.push(FadePlugin(target, options));
        } else if (target.dataset.keenTransition == 'zoom') {
            plugins.push(ZoomPlugin(target, options));
        }
    }

    // Controls / Indicators Plugin
    if (target.dataset.keenControls) {
        plugins.push(ControlsPlugin(target, options));
    }
    if (target.dataset.keenIndicators) {
        plugins.push(IndicatorsPlugin(target, options));
    }

    // Return Keen Instance
    return new KeenSlider(target, { ...options }, [ ...plugins ]);
}


/**
 * Export KeenSlider Plugin
 * @returns 
 */
export default async function () {
    await ready();

    query('[data-keen-slider]', slider => invokeKeenSlider(slider as HTMLElement));
};

// Export Module
export { invokeKeenSlider };
